/**
 * @fileoverview Years-of-experience selects for each sector the company attends.
 */

import Select from "react-select";
import { getSelectedOption, selectStyles } from "../../../utils/common";
import styles from "./Certifications.module.css";

const SectorExperienceTabletRow = ({
  rowSectors,
  yearsOptions,
  onExperienceChange,
  t,
}) => (
  <div className={styles.inputRow}>
    {rowSectors.map((sector) => (
      <div key={`select-${sector.value}`} className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t(`components.certifications.sectorOption${sector.value + 1}`)}
        </label>
        <Select
          value={getSelectedOption(yearsOptions, sector.experience)}
          onChange={(selectedOption) =>
            onExperienceChange(sector.value, selectedOption)
          }
          options={yearsOptions}
          placeholder={t(
            "components.certifications.yearsOfExperienceInTheSectorPlaceholder",
          )}
          styles={selectStyles}
          className="select__control"
        />
      </div>
    ))}
  </div>
);

const SectorExperienceDesktopBlock = ({
  rowIndex,
  rowSectors,
  yearsOptions,
  onExperienceChange,
  t,
}) => (
  <>
    <div key={`sector-label-row-${rowIndex}`} className={styles.checkboxRow}>
      {rowSectors.map((sector) => (
        <div key={`label-${sector.value}`} className={styles.checkboxItem}>
          <label
            className={`${styles.checkboxLabel} ${styles.specialCheckboxLabel}`}
          >
            {t(`components.certifications.sectorOption${sector.value + 1}`)}
          </label>
        </div>
      ))}
    </div>
    <div key={`sector-select-row-${rowIndex}`} className={styles.checkboxRow}>
      {rowSectors.map((sector) => (
        <div key={`select-${sector.value}`} className={styles.checkboxItem}>
          <Select
            value={getSelectedOption(yearsOptions, sector.experience)}
            onChange={(selectedOption) =>
              onExperienceChange(sector.value, selectedOption)
            }
            options={yearsOptions}
            placeholder={t(
              "components.certifications.yearsOfExperienceInTheSectorPlaceholder",
            )}
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                borderRadius: "8px",
                fontSize: "14px",
                cursor: "pointer",
                borderColor: baseStyles.borderColor,
                marginBottom: "-10px",
                width: "300px",
              }),
              container: (baseStyles) => ({
                ...baseStyles,
              }),
              valueContainer: (baseStyles) => ({
                ...baseStyles,
              }),
              input: (baseStyles) => ({
                ...baseStyles,
              }),
              option: (baseStyles) => ({
                ...baseStyles,
                cursor: "pointer",
              }),
              indicatorSeparator: () => ({ display: "none" }),
            }}
          />
        </div>
      ))}
    </div>
  </>
);

const SectorExperienceRows = ({
  sectors,
  isTablet,
  yearsOptions,
  onExperienceChange,
  t,
}) => {
  if (sectors.length === 0) {
    return null;
  }

  const rows = [];
  const sectorsPerRow = isTablet ? 2 : 4;

  for (let i = 0; i < sectors.length; i += sectorsPerRow) {
    const rowSectors = sectors.slice(i, i + sectorsPerRow);

    if (isTablet) {
      // Tablet view: 2 per row with inputRow structure
      rows.push(
        <SectorExperienceTabletRow
          key={`sector-select-row-${i}`}
          rowSectors={rowSectors}
          yearsOptions={yearsOptions}
          onExperienceChange={onExperienceChange}
          t={t}
        />,
      );
    } else {
      // Desktop/Mobile view: 4 per row with checkboxRow structure
      rows.push(
        <SectorExperienceDesktopBlock
          key={`sector-desktop-${i}`}
          rowIndex={i}
          rowSectors={rowSectors}
          yearsOptions={yearsOptions}
          onExperienceChange={onExperienceChange}
          t={t}
        />,
      );
    }
  }

  return rows;
};

export default SectorExperienceRows;
